import { render, staticRenderFns } from "./checkboxitem.vue?vue&type=template&id=c58c80d0&"
import script from "./checkboxitem.vue?vue&type=script&lang=ts&"
export * from "./checkboxitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58c80d0')) {
      api.createRecord('c58c80d0', component.options)
    } else {
      api.reload('c58c80d0', component.options)
    }
    module.hot.accept("./checkboxitem.vue?vue&type=template&id=c58c80d0&", function () {
      api.rerender('c58c80d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/checkboxitem.vue"
export default component.exports